if (!customElements.get('filter-display-cta')) {
  class FilterDisplayCta extends HTMLElement {
    constructor() {
      super();
      this.filterShow = true;
      this.verticalFacets = document.querySelector('.facets-vertical > aside#main-collection-filters');
      this.addEventListener('click', () => {
        if (this.filterShow === true) {
          this.hideFilters();
        } else {
          this.showFilters();
        }
        this.filterShow = !this.filterShow;
      });
    }

    hideFilters() {
      if (this.verticalFacets) {
        this.verticalFacets.style.maxWidth = '0px';
        this.verticalFacets.style.paddingRight = '0px';
        const text = this.querySelector('span');
        text.textContent = 'Show filters';
      }
    }

    showFilters() {
      if (this.verticalFacets) {
        const scrollWidth = this.verticalFacets.scrollWidth + 30 + 'px';
        this.verticalFacets.style.maxWidth = scrollWidth;
        this.verticalFacets.style.paddingRight = '3rem';
        const text = this.querySelector('span');
        text.textContent = 'Hide filters';
      }
    }
  }

  customElements.define('filter-display-cta', FilterDisplayCta);
}